var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 49.73",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m25 2.36 2.61-2.36 2.07 2.85 3.05-1.76 1.42 3.22 3.35-1.1.73 3.45 3.5-.38-.01 3.53 3.51.36-.74 3.44 3.35 1.08-1.44 3.22 3.05 1.76-2.07 2.84 2.62 2.35-2.62 2.35 2.07 2.85-3.05 1.76 1.44 3.21-3.35 1.08.74 3.45-3.51.36.01 3.52-3.5-.37-.73 3.44-3.35-1.09-1.42 3.22-3.05-1.77-2.07 2.86-2.61-2.37-2.61 2.37-2.07-2.86-3.05 1.77-1.42-3.22-3.35 1.09-.73-3.44-3.5.37.01-3.52-3.51-.36.74-3.45-3.35-1.08 1.44-3.21-3.05-1.76 2.07-2.85-2.62-2.35 2.62-2.35-2.07-2.84 3.05-1.76-1.44-3.22 3.35-1.08-.74-3.44 3.51-.36-.01-3.53 3.5.38.73-3.45 3.35 1.1 1.42-3.22 3.05 1.76 2.07-2.85z",
    fill: "#e6b455"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#002e80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.51 18.48h3.93l2.14 6.91v-6.91h2.59v13.57h-3.93l-2.14-6.91v6.91h-2.59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.61 18.48h7.18v2.57h-3.57v2.79h3.19v2.55h-3.19v3.05h3.77v2.59h-7.38v-13.57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.52 18.48h3.79l.68 8.08 1.2-8.08h3.13l1.22 8.08.66-8.08h2.87l-1.74 13.57h-4.09l-1.02-7.12-1.04 7.12h-3.91l-1.76-13.57z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.243ce4c0fce533073406de0353e472de.svg";
export { ForwardRef as ReactComponent };